import { Button, useRefresh, useNotify, TextInput, maxLength } from "react-admin";
import { Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FormModal from "server/components/Modals/FormModal";
import { employeeRequests } from "api/employeeApi";
import dataProvider from "server/dataProvider";
import { CANCELABLE_WHEN_APPROVED_TYPES, StaffRequestStatuses } from "utils/constants";

const CancelRequestDialog = ({ record, requestType, iconOnly = false }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const id = record?.leaveId ?? record?.id; // vacations use leaveId; others use id
  const status = record?.staffRequest?.status;

  const isCancelable =
    status === StaffRequestStatuses.Pending ||
    (status === StaffRequestStatuses.Approved && CANCELABLE_WHEN_APPROVED_TYPES.includes(requestType));

  if (!id || !isCancelable) return null;

  const handleCancel = async data => {
    const payload = { ...(data?.cancellationReason && { cancellationReason: data.cancellationReason }) };
    const { status: responseStatus } = await dataProvider.customRequest(
      employeeRequests.cancelStaffRequest(id),
      payload,
      "PUT",
    );

    // An already approved request is not cancelled outright; a cancellation request is created instead.
    notify(responseStatus === 201 ? "Заявката за отмяна е изпратена за одобрение" : "Заявката е успешно отменена", {
      type: "success",
    });
    refresh();
  };

  return (
    <FormModal
      onConfirm={handleCancel}
      titleContent="Отмяна на заявка"
      saveTitle="Отмени заявката"
      closeTitle="Назад"
      triggerButton={
        <Button
          label={iconOnly ? "" : "Отмени"}
          color="error"
        >
          <DeleteForeverIcon />
        </Button>
      }
    >
      <Typography sx={{ my: 2, fontWeight: "bold" }}>Сигурни ли сте, че искате да отмените заявката?</Typography>
      <TextInput
        source="cancellationReason"
        label="Причина за отмяна (незадължително)"
        fullWidth
        multiline
        minRows={2}
        validate={[maxLength(500)]}
      />
    </FormModal>
  );
};

export default CancelRequestDialog;
